export default __webpack_public_path__ + "static/media/photo--sm--114.07ac5c33.jpg";